var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1217 25.5114C29.5539 26.1386 30.8408 27.0555 31.9012 28.2045C32.0619 28.3821 32.1533 28.6117 32.1586 28.8512V32.8109C32.1586 33.0734 32.0543 33.3252 31.8686 33.5109C31.683 33.6965 31.4312 33.8008 31.1687 33.8008H15.9899C15.7296 33.8008 15.4798 33.6983 15.2946 33.5155C15.1093 33.3327 15.0035 33.0843 15 32.8241V28.8644C15.0021 28.6203 15.0937 28.3855 15.2574 28.2045C16.3178 27.0555 17.6047 26.1386 19.0369 25.5114C20.4692 24.8843 22.0158 24.5605 23.5793 24.5605C25.1428 24.5605 26.6894 24.8843 28.1217 25.5114Z",
    fill: "#99396D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5786 23.2392C26.1299 23.2392 28.1982 21.171 28.1982 18.6196C28.1982 16.0683 26.1299 14 23.5786 14C21.0273 14 18.959 16.0683 18.959 18.6196C18.959 21.171 21.0273 23.2392 23.5786 23.2392Z",
    fill: "#99396D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel4);
export default __webpack_public_path__ + "static/media/icone-rel-4.9e1f5b37aa857603541482683556e4c7.svg";
export { ForwardRef as ReactComponent };